import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import { isSafari, isIE, browserVersion, isChrome, isFirefox, isMacOs } from 'react-device-detect'

import './intercept';

// Components
import AlertOutdatedBrowser from "../components/AlertOutdatedBrowser";

// Redux
import { promptUser } from '../redux/actions/notificationsActions'

// Helpers
import withNotifications from '../helpers/NotificationsHoc';
import withPrompts from '../helpers/PromptsHoc';

class MainWrapper extends PureComponent {

  componentDidMount() {
    if(this.validVersionsBrowsers()) {
      return this.props.promptUser({
        title: 'Version del navegador desactualizado',
        message: 'La version del navegador que estas utilizado esta desactualizada, te invitamos a descargar una version mas reciente de tu navegador',
        color: 'info'
      })
      .then(confirmation => {
        console.log(confirmation)
      });
    }
  }

  validVersionsBrowsers = () => {
    if (isChrome && browserVersion < 70) return true
    if (isFirefox && browserVersion < 65) return true

    return false
  }

  invalidBrowsers = () => {
    if (isIE) return false
    if (isSafari && browserVersion < 11 && isMacOs) return false

    return true

  }

  isLogin = (href) => {
    if (href.indexOf('login') > 0) return true
    if (href.indexOf('signup') > 0) return true

    return false

  }

  typeContent = () => {
    let wrapperClass = classNames({
      'wrapper': true,
      'wrapper--full-width': this.props.sidebar.collapse,
      'squared-corner-theme': this.props.detailsPanel.squaredCorners,
      'blocks-with-shadow-theme': this.props.detailsPanel.withBoxShadow,
      'top-navigation': this.props.detailsPanel.topNavigation

    }); // END wrapperClass

    const theme = this.props.theme.className;

    if(!this.invalidBrowsers()) {
      return (
        <div className={ theme }>
          <AlertOutdatedBrowser />
        </div>
      )
    } else {
      return (
        <div className={ theme }>
          <div className={ wrapperClass }>
            { this.props.children }
          </div>
        </div>)
    }
  }

  render() {
    return this.typeContent()
  }
}

export default connect(state => ({
  appUser: state.account,
  theme: state.theme,
  sidebar: state.sidebar,
  detailsPanel: state.detailsPanel,
  alertDisplayed: get(state, 'account.alertDisplayed')

}), { promptUser })(withNotifications(withPrompts(MainWrapper)));



// WEBPACK FOOTER //
// ./src/app/MainWrapper.js